import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/messages-management/conversation/:userId`;

export const chatManagementRoutesObj = {
  view: baseRoute,
} as const;

export type IChatManagementRouteParams = IExtractRouteParamMap<
  typeof chatManagementRoutesObj
>;

export const chatManagementPath = createPaths<
  typeof chatManagementRoutesObj,
  IChatManagementRouteParams
>(chatManagementRoutesObj);
